function OpenStatus() {
  return (
    <div className="w-[84px] h-[22px] flex items-center justify-center rounded-[11px] bg-wo_color2 font-OpenSansRegular font-[400] text-titleColor text-[10px]">
      OPEN
    </div>
  );
}

export default OpenStatus;
